import { setNewUUID, TABLE_STATUS_AVAILABLE } from "../store/state";

export const LIST_SESSIONS = "ListSessions";
export const GET_TABLE = "GetTable";
export const GET_SESSION = "GetSession";
export const GET_BILL_ITEMS = "GetBillItems";
export const GET_FULL_BILL = "GetFullBill";
export const LIST_BILL_ITEMS = "ListBillItems";
export const LIST_TABLES = "ListTables";
export const LOCK_SESSION = "LockSession";
export const UNLOCK_SESSION = "UnlockSession";
export const RECORD_PAYMENT = "RecordPayment";
export const DISCONNECT = "Disconnect";

export const TABLE_NO_SUCH_TABLE = "TABLE_NO_SUCH_TABLE";
export const SESSION_NO_SUCH_SESSION = "SESSION_NO_SUCH_SESSION";
export const SESSION_NOT_LOCKED = "SESSION_NOT_LOCKED";
export const SESSION_ALREADY_LOCKED = "SESSION_ALREADY_LOCKED";
export const SESSION_UNABLE_TO_UNLOCK = "SESSION_UNABLE_TO_UNLOCK";
export const PAYMENT_NOT_RECORDED = "PAYMENT_NOT_RECORDED";
export const PAYMENT_ALREADY_RECORDED = "PAYMENT_ALREADY_RECORDED";

export const PAYMENT_METHOD_CARD_PRESENT = "PAYMENT_METHOD_CARD_PRESENT";
export const PAYMENT_METHOD_REMOTE = "PAYMENT_METHOD_REMOTE";

export const ALIGN_CENTER = "ALIGN_CENTER";
export const HORIZONTAL_LINE_DOUBLE = "HORIZONTAL_LINE_DOUBLE";
export const HORIZONTAL_LINE_SINGLE = "HORIZONTAL_LINE_SINGLE";
export const RECEIPT_LINE_TYPE_HORIZONTAL_LINE = "RECEIPT_LINE_TYPE_HORIZONTAL_LINE";
export const RECEIPT_LINE_TYPE_LOGO = "RECEIPT_LINE_TYPE_LOGO";
export const RECEIPT_LINE_TYPE_MERCHANT_ADDRESS = "RECEIPT_LINE_TYPE_MERCHANT_ADDRESS";
export const RECEIPT_LINE_TYPE_MERCHANT_EMAIL_ADDRESS = "RECEIPT_LINE_TYPE_MERCHANT_EMAIL_ADDRESS";
export const RECEIPT_LINE_TYPE_MERCHANT_NAME = "RECEIPT_LINE_TYPE_MERCHANT_NAME";
export const RECEIPT_LINE_TYPE_MERCHANT_PHONE_NUMBER = "RECEIPT_LINE_TYPE_MERCHANT_PHONE_NUMBER";
export const RECEIPT_LINE_TYPE_URL = "RECEIPT_LINE_TYPE_URL";
export const RECEIPT_LINE_TYPE_TEXT = "RECEIPT_LINE_TYPE_TEXT";
export const RECEIPT_LINE_TYPE_VAT_NUMBER = "RECEIPT_LINE_TYPE_VAT_NUMBER";
export const SIZE_BODY = "SIZE_BODY";
export const SIZE_HEADER_2 = "SIZE_HEADER_2";

export function listSesssionsResponse(request, tableList, completedSessions) {
  let sessions = [];
  let validSessions = tableList;
  validSessions = validSessions.filter(session => session.status !== TABLE_STATUS_AVAILABLE);
  completedSessions.forEach(session => validSessions.push(session));
  validSessions.forEach(table => {
    const session = getSession(table);

    if (request.params) {
      let includeSession = true;
      if (includeSession !== false && request.params.isFinished !== undefined) {
        includeSession = (request.params.isFinished === (session.finishedAt !== undefined));
      }
      if (includeSession !== false && request.params.hasTable !== undefined) {
        includeSession = (request.params.hasTable === (session.name !== ""));
      }
      if (includeSession !== false && request.params.isPayable !== undefined) {
        includeSession = (request.params.isPayable === (session.isPayable));
      }
      if (includeSession !== false && request.params.tableNames !== undefined) {
        if (Array.isArray(request.params.tableNames) && request.params.tableNames.length > 0) {
          const tableNames = request.params.tableNames[0].split(", ");
          includeSession = (tableNames.includes(session.tableName));
        }
      }
      if (includeSession === true) {
        sessions.push(session);
      }
    }
    else {
      sessions.push(session)
    }
  });
  const data = { sessions: sessions };
  return wrapTablesResponse(request, data);
}

export function findSession(sessionId, tableList, completedSessions) {
  const validSessions = tableList.filter(session => session.status !== TABLE_STATUS_AVAILABLE);
  completedSessions.forEach(session => validSessions.push(session));
  return validSessions.filter(s => s.id.toString() === sessionId)[0];
}

export function getSesssionResponse(request, tableList, completedSessions) {
  const session = findSession(request.params.sessionId, tableList, completedSessions);
  if (session) {
    const data = { session: getSession(session) };
    return wrapTablesResponse(request, data)
  } else {
    return sendErrorResponse(request, SESSION_NO_SUCH_SESSION, "The requested session does not exist!");
  }
}

export function recordPaymentResponse(request, tableList, setTableList, completedSessions, setCompletedSessions, paymentList, setPaymentList, closedTableList, setClosedTableList) {
  const paymentData = request.params.payment;
  const session = findSession(paymentData.sessionId, tableList, completedSessions);
  if (session) {
    if (session.isLocked) {
      if (paymentData.paymentSuccessful) {
        if (!paymentList.find(p => p.id === paymentData.id && p.sessionId === paymentData.sessionId)) {
          const newTableList = tableList;

          const payment = recordPayment(paymentData, newTableList, session);
          const newPaymentList = paymentList;
          newPaymentList.push(payment)
          setPaymentList([...newPaymentList]);

          if (newTableList[session.number - 1].total <= 0) {
            // Update the closed tables list
            const newClosedTableList = closedTableList;
            newClosedTableList.push({
              time: payment.date,
              table: payment.tableNumber,
              balance: session.subTotal
            })

            // Add the session data to the list of completed sessions
            const finishedSession = getSession(session);
            finishedSession.finishedAt = new Date().toISOString();
            finishedSession.name = "";
            completedSessions.push(finishedSession);
            setCompletedSessions([...completedSessions]);

            // Reset the table
            newTableList[session.number - 1].id = setNewUUID();
            newTableList[session.number - 1].status = TABLE_STATUS_AVAILABLE;
            newTableList[session.number - 1].serviceCharge = 0;
            newTableList[session.number - 1].subTotal = 0;
            newTableList[session.number - 1].total = 0;
            newTableList[session.number - 1].paid = 0;
            newTableList[session.number - 1].items = [];
            newTableList[session.number - 1].posItemsActive = true;
            newTableList[session.number - 1].isLocked = false;

            setClosedTableList([...newClosedTableList])
          }

          setTableList([...newTableList]);
          return wrapTablesResponse(request, {})
        } else {
          return sendErrorResponse(request, PAYMENT_ALREADY_RECORDED, "The payment was already recorded!");
        }
      } else {
        return sendErrorResponse(request, PAYMENT_NOT_RECORDED, "The payment was not successful!");
      }
    } else {
      return sendErrorResponse(request, SESSION_NOT_LOCKED, "The requested session is not locked!");
    }
  } else {
    return sendErrorResponse(request, SESSION_NO_SUCH_SESSION, "The requested session does not exist!");
  }
}

export function getTableResponse(request, tableList, completedSessions) {
  const table = tableList.filter(t => t.name === request.params.name)[0];
  if (table) {
    const data = { table: getTable(table) };
    return wrapTablesResponse(request, data)
  } else {
    return sendErrorResponse(request, TABLE_NO_SUCH_TABLE, "The requested table does not exist!");
  }
}

export function listTablesResponse(request, tableList) {
  let tables = [];
  const statuses = request.params.statuses;
  tableList.forEach(table => {
    if (statuses.length > 0) {
      if (statuses && statuses.includes(table.status)) {
        tables.push(getTable(table))
      }
    } else {
      tables.push(getTable(table))
    }
  });
  const data = { tables: tables };
  return wrapTablesResponse(request, data);
}

export function unlockSessionResponse(request, tableList, setTableList) {
  const session = findSession(request.params.sessionId, tableList, []);
  if (session) {
    if (session.isLocked === false) {
      return sendErrorResponse(request, SESSION_UNABLE_TO_UNLOCK, "The requested session is already unlocked!")
    } else {
      const newTableList = tableList;
      tableList[session.number - 1].isLocked = false;
      setTableList([...newTableList]);
      return wrapTablesResponse(request, {});
    }
  } else {
    return sendErrorResponse(request, SESSION_NO_SUCH_SESSION, "The requested session does not exist!");
  }
}

export function lockSessionResponse(request, tableList, setTableList) {
  const session = findSession(request.params.sessionId, tableList, []);
  if (session) {
    if (session.isLocked === true) {
      return sendErrorResponse(request, SESSION_ALREADY_LOCKED, "The requested session is already locked!")
    } else {
      const newTableList = tableList;
      newTableList[session.number - 1].isLocked = true;
      setTableList([...newTableList]);
      const data = { billItems: getBillItems(session) };
      return wrapTablesResponse(request, data);
    }
  } else {
    return sendErrorResponse(request, SESSION_NO_SUCH_SESSION, "The requested session does not exist!");
  }
}

export function getBillItemsResponse(request, tableList, completedSessions) {
  const session = findSession(request.params.sessionId, tableList, completedSessions);
  if (session) {
    const data = { billItems: getBillItems(session) };
    return wrapTablesResponse(request, data)
  } else {
    return sendErrorResponse(request, SESSION_NO_SUCH_SESSION, "The requested session does not exist!");
  }
}

export function getFullBillResponse(request, tableList, completedSessions) {
  const session = findSession(request.params.sessionId, tableList, completedSessions);
  if (session) {
    const data = {
      fullBill: {
        billItems: getBillItems(session),
        header: getHeader(),
        footer: getFooter()
      }
    };
    return wrapTablesResponse(request, data)
  } else {
    return sendErrorResponse(request, SESSION_NO_SUCH_SESSION, "The requested session does not exist!");
  }
}

export function listBillItemsResponse(request, tableList) {
  const billItems = [];
  const sessionIds = request.params.sessionIds;
  const validSessions = tableList.filter(session => session.status !== TABLE_STATUS_AVAILABLE);
  validSessions.forEach(session => {
    if (sessionIds && sessionIds.length > 0) {
      if (sessionIds.includes(session.id)) {
        billItems.push(getBillItems(session));
      }
    } else {
      billItems.push(getBillItems(session));
    }
  });
  const data = { billItems: billItems };
  return wrapTablesResponse(request, data)
}

function recordPayment(payment, tableList, session) {
  tableList[session.number - 1].paid += payment.baseAmount;
  tableList[session.number - 1].total -= payment.baseAmount;

  let authCode = "";
  if (payment.methodDetails.method === PAYMENT_METHOD_CARD_PRESENT) {
    authCode = payment.methodDetails.cardPresentPaymentInfo.authCode
  } else if (payment.methodDetails.method === PAYMENT_METHOD_REMOTE) {
    authCode = payment.methodDetails.remotePaymentInfo.authCode;
  }

  return {
    id: payment.id,
    sessionId: session.id,
    tableNumber: session.number,
    authCode: authCode,
    paymentMethod: payment.methodDetails.method,
    date: payment.attemptedAt,
    baseAmount: payment.baseAmount,
    gratuityAmount: payment.gratuityAmount,
  }
}

function getBillItemsItem(item) {
  const modifiers = [];
  if (item.modifiers) {
    item.modifiers.forEach(modifier => modifiers.push(getBillItemModifier(modifier)))
  }
  return {
    id: item.key.toString(),
    name: item.name,
    quantity: item.quantity,
    amountPerItem: item.price,
    lastOrderedAt: new Date().toISOString(),
    category: item.category,
    modifiers: modifiers
  }
}

function getBillItemModifier(modifier) {
  return {
    id: modifier.key,
    name: modifier.name,
    amountPerModifier: modifier.price,
    quantity: modifier.quantity
  }
}

function getBillItems(session) {
  const items = [];
  if (session.items) {
    session.items.forEach(item => items.push(getBillItemsItem(item)))
  }

  const response = {
    sessionId: session.id,
    totalAmount: session.total + session.paid,
    paidAmount: session.paid,
    serviceCharge: session.serviceCharge,
    taxAmount: parseInt(session.total * .2),
    currency: "GBP",
    items: items,
  }

  return response;
}

function getFooter() {
  return {
    receiptLines: [
      {
        receiptLineType: RECEIPT_LINE_TYPE_HORIZONTAL_LINE,
        receiptHorizontalLine: {
          type: HORIZONTAL_LINE_DOUBLE
        }
      },
      {
        receiptLineType: RECEIPT_LINE_TYPE_TEXT,
        receiptText: {
          value: "Thanks for dining with us!",
          size: SIZE_BODY,
          align: ALIGN_CENTER
        }
      },
      {
        receiptLineType: RECEIPT_LINE_TYPE_TEXT,
        receiptText: {
          value: "Scan below to enter a survey",
          size: SIZE_BODY,
          align: ALIGN_CENTER
        }
      },
      {
        receiptLineType: RECEIPT_LINE_TYPE_URL,
        receiptURL: {
          description: "Voucher code!",
          showQR: true,
          url: "https://bobs-shop.com/voucher-link"
        }
      },
      {
        receiptLineType: RECEIPT_LINE_TYPE_VAT_NUMBER,
        receiptVATNumber: {
          vatNumber: "123456789"
        }
      }
    ]
  };
}

function getHeader() {
  return {
    receiptLines: [
      {
        receiptLineType: RECEIPT_LINE_TYPE_LOGO,
        receiptLogo: {
          svgImage: "<path d=\\\"M127.230822,29.0095321 L127.230822,44.8571699 L127.228945,44.857 L127.226632,45.0782852 C127.101225,49.363888 124.174005,52.9391141 120.231189,53.999935 L120.230818,49.0517119 C121.686353,48.2013585 122.665635,46.6119543 122.665635,44.7915457 L122.665595,29.0095321 L127.230822,29.0095321 Z M98.8846365,22 L98.8846365,38.4687967 C98.8846365,43.6902675 94.6571667,47.923106 89.4423183,47.923106 C84.2274699,47.923106 80,43.6902675 80,38.4687967 C80,33.2473259 84.2274699,29.0144875 89.4423183,29.0144875 C91.2255567,29.0144875 92.8933384,29.5094441 94.3161065,30.3696359 L94.3157729,22 L98.8846365,22 Z M150.711618,43.6154088 C151.890535,43.6154088 152.846235,44.5711098 152.846235,45.7500266 C152.846235,46.9289435 151.890535,47.8846444 150.711618,47.8846444 C149.532701,47.8846444 148.577,46.9289435 148.577,45.7500266 C148.577,44.5711098 149.532701,43.6154088 150.711618,43.6154088 Z M139.134682,29.0000078 C144.34953,29.0000078 148.577,33.2274777 148.577,38.4423261 C148.577,43.6571745 144.34953,47.8846444 139.134682,47.8846444 C133.919833,47.8846444 129.692363,43.6571745 129.692363,38.4423261 C129.692363,33.2274777 133.919833,29.0000078 139.134682,29.0000078 Z M110.788496,29.0000078 C116.003344,29.0000078 120.230814,33.2274777 120.230814,38.4423261 C120.230814,43.6571745 116.003344,47.8846444 110.788496,47.8846444 C105.573648,47.8846444 101.346178,43.6571745 101.346178,38.4423261 C101.346178,33.2274777 105.573648,29.0000078 110.788496,29.0000078 Z M150.711618,44.1490633 C149.82743,44.1490633 149.110654,44.865839 149.110654,45.7500266 C149.110654,46.6342142 149.82743,47.3509899 150.711618,47.3509899 C151.595805,47.3509899 152.312581,46.6342142 152.312581,45.7500266 C152.312581,44.865839 151.595805,44.1490633 150.711618,44.1490633 Z M150.787549,44.7437068 L150.916706,44.7499643 C151.081083,44.7666509 151.214137,44.8167107 151.315867,44.9001438 C151.443029,45.0044351 151.50661,45.1526386 151.50661,45.3447542 C151.50661,45.4783203 151.474591,45.5903877 151.410553,45.6809565 C151.346514,45.7715253 151.25686,45.8369361 151.141591,45.8771888 L151.141591,45.8771888 L151.539544,46.5770385 L151.54572,46.5928195 L151.54572,46.5928195 L151.547778,46.6072281 C151.547778,46.6236952 151.541832,46.6374177 151.529939,46.6483958 C151.518046,46.6593738 151.504781,46.6648628 151.490143,46.6648628 L151.490143,46.6648628 L151.237649,46.6648628 L151.198539,46.6597169 L151.198539,46.6597169 L151.169036,46.644279 C151.152569,46.6305564 151.137931,46.6127171 151.125124,46.5907611 L151.125124,46.5907611 L150.773827,45.9403125 L150.397829,45.9403125 L150.397829,46.5989946 L150.393026,46.6243813 L150.393026,46.6243813 L150.378617,46.6456512 C150.36581,46.658459 150.349343,46.6648628 150.329216,46.6648628 L150.329216,46.6648628 L150.076721,46.6648628 L150.051335,46.6600599 L150.051335,46.6600599 L150.030065,46.6456512 C150.017257,46.6328435 150.010853,46.6172913 150.010853,46.5989946 L150.010853,46.5989946 L150.010853,44.8123195 L150.015313,44.7848744 L150.015313,44.7848744 L150.028692,44.7629184 C150.040585,44.7501107 150.056595,44.7437068 150.076721,44.7437068 L150.076721,44.7437068 L150.787549,44.7437068 Z M150.779316,45.0510918 L150.397829,45.0510918 L150.397829,45.6274386 L150.779316,45.6274386 C150.889096,45.6274386 150.971431,45.6031954 151.026321,45.5547091 C151.081212,45.5062228 151.108657,45.435323 151.108657,45.3420097 C151.108657,45.2486964 151.081212,45.1768817 151.026321,45.1265658 C150.971431,45.0762498 150.889096,45.0510918 150.779316,45.0510918 L150.779316,45.0510918 Z M89.4423183,33.5891533 C86.7507836,33.5891533 84.5688637,35.7738441 84.5688637,38.4687967 C84.5688637,41.1637494 86.7507836,43.3484402 89.4423183,43.3484402 C92.1338529,43.3484402 94.3157729,41.1637494 94.3157729,38.4687967 C94.3157729,35.7738441 92.1338529,33.5891533 89.4423183,33.5891533 Z M139.134682,33.5688715 C136.443147,33.5688715 134.261227,35.7507915 134.261227,38.4423261 C134.261227,41.1338608 136.443147,43.3157807 139.134682,43.3157807 C141.826216,43.3157807 144.008136,41.1338608 144.008136,38.4423261 C144.008136,35.7507915 141.826216,33.5688715 139.134682,33.5688715 Z M110.788496,33.5688715 C108.096961,33.5688715 105.915041,35.7507915 105.915041,38.4423261 C105.915041,41.1338608 108.096961,43.3157807 110.788496,43.3157807 C113.480031,43.3157807 115.661951,41.1338608 115.661951,38.4423261 C115.661951,35.7507915 113.480031,33.5688715 110.788496,33.5688715 Z M124.948209,22 C126.208861,22 127.230822,23.0233504 127.230822,24.285717 C127.230822,25.5480836 126.208861,26.571434 124.948209,26.571434 C123.687556,26.571434 122.665595,25.5480836 122.665595,24.285717 C122.665595,23.0233504 123.687556,22 124.948209,22 Z\\\" id=\\\"Combined-Shape-Copy-87\\\"></path>\n"
        }
      },
      {
        receiptLineType: RECEIPT_LINE_TYPE_MERCHANT_NAME,
        receiptMerchantName: {
          merchantName: "Jan's Diner"
        }
      },
      {
        receiptLineType: RECEIPT_LINE_TYPE_MERCHANT_PHONE_NUMBER,
        receiptMerchantPhoneNumber: {
          phoneNumber: "01234 567890"
        }
      },
      {
        receiptLineType: RECEIPT_LINE_TYPE_MERCHANT_EMAIL_ADDRESS,
        receiptMerchantEmailAddress: {
          emailAddress: "info@jansdiner.com"
        }
      },
      {
        receiptLineType: RECEIPT_LINE_TYPE_MERCHANT_ADDRESS,
        receiptMerchantAddress: {
          addressLines: [
            "1",
            "High Street",
            "London"
          ],
          "postcode": "ABC 123"
        }
      },
      {
        receiptLineType: RECEIPT_LINE_TYPE_TEXT,
        receiptText: {
          value: "Here is your bill",
          size: SIZE_HEADER_2,
          align: ALIGN_CENTER
        }
      },
      {
        receiptLineType: RECEIPT_LINE_TYPE_HORIZONTAL_LINE,
        receiptHorizontalLine: {
          type: HORIZONTAL_LINE_SINGLE
        }
      }
    ]
  };
}

function getSession(table) {
  if (!table.items) {
    table.items = [];
  }
  const session = {
    id: table.id,
    name: table.total ? table.total.toString() : table.name,
    numberOfCovers: table.numberOfCovers ? table.numberOfCovers : wordToNumber(table.seats),
    tableName: table.name,
    createdAt: new Date().toISOString(),
    isPayable: table.items.length > 0
  }
  if (table.finishedAt !== undefined) {
    session.finishedAt = table.finishedAt;
  }
  return session;
}

function getTable(table) {
  return {
    name: table.name,
    maxCovers: wordToNumber(table.seats),
    status: table.status
  }
}

function sendErrorResponse(request, code, reason) {
  return {
    id: request.id,
    jsonrpc: "2.0",
    result: {
      errorCode: code,
      errorReason: reason
    }
  }
}

function wrapTablesResponse(request, data) {
  return {
    id: request.id,
    jsonrpc: "2.0",
    result: data
  }
}

function wordToNumber(word) {
  switch (word) {
    default: return 0;
    case "two": return 2;
    case "six": return 6;
    case "eight": return 8;
  }
}
